import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { langConversionHelper } from "@/_helpers";
import { USA, Australia } from "@/_helpers/CountryConstants";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";

import LanguageIcon from "@mui/icons-material/Language";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery } from "@mui/material";

const CustomIconButton = styled(IconButton)({
  height: 59,
  width: 59,
  padding: 4,
});

const lngs = langConversionHelper.languageList();

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const isMountedRef = useRef(null);
  const cookies = new Cookies();
  const siteCountry = cookies.get("siteCountry") || USA;
  const enrollNowCookie = cookies.get("EnrollNow") || {};

  const isCustomRange = useMediaQuery(
    "(min-width:900px) and (max-width:1056px)"
  );

  const handleUserCookieUpdate = (newLangID) => {
    if (enrollNowCookie !== undefined) {
      let updatedCookie = {
        ...enrollNowCookie,
        Language: newLangID,
      };
      cookies.set("EnrollNow", JSON.stringify(updatedCookie), {
        path: "/",
        sameSite: "strict",
      });
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (
      siteCountry === Australia &&
      (i18n.language === "enUS" ||
        i18n.language === "en-US" ||
        i18n.language === "en")
    ) {
      i18n.changeLanguage("enAU");
    }
    return () => (isMountedRef.current = false);
  }, [selectedLanguage, siteCountry, i18n]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid>
        <Tooltip title={t("policies.language")}>
          <CustomIconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
            sx={{
              paddingLeft:isCustomRange ? "40px" : "0px"
            }}
          >
            <ArrowDropDownIcon fontSize="small" style={{ marginLeft: -6 }} />
            <LanguageIcon
              style={{ width: 32, height: 32, marginLeft: -6 }}
              color="primary"
            />
          </CustomIconButton>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {lngs.map((lng) => (
            <MenuItem
              key={lng.langAbbrev}
              style={{
                fontWeight: i18n.language === lng.langAbbrev ? 600 : "normal",
              }}
              onClick={() => {
                i18n.changeLanguage(lng.langAbbrev);
                setSelectedLanguage(lng.langAbbrev);
                handleUserCookieUpdate(lng.langAbbrev);
                setAnchorEl(null);
                localStorage.setItem("lang", lng.langAbbrev);
              }}
            >
              {lng.nativeName}
            </MenuItem>
          ))}
        </Menu>
      </Grid>
    </Grid>
  );
};

